import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Cursor: { input: any; output: any };
  Id: { input: string; output: string };
  Timestamp: { input: string; output: string };
};

export type Annotation = {
  __typename?: 'Annotation';
  content: Scalars['String']['output'];
  coordinates: LatLng;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Id']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

/**
 * ---
 *
 * ## Club entity represents a golf club with metadata.
 * Includes CDC annotations used by downstream tooling.
 */
export type Club = {
  __typename?: 'Club';
  /** Country code (ISO 3166-1 alpha-2). */
  country: Scalars['String']['output'];
  courses: Array<Course>;
  createdAt: Scalars['Timestamp']['output'];
  foundedYear?: Maybe<Scalars['Int']['output']>;
  holes: Array<Hole>;
  id: Scalars['Id']['output'];
  /** Human-friendly club name. */
  name: Scalars['String']['output'];
  players: Array<Player>;
  /** URL-safe slug for the club. */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ClubBy = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ClubConnection = {
  __typename?: 'ClubConnection';
  /** A list of edges. */
  edges: Array<ClubEdge>;
  /** A list of nodes. */
  nodes: Array<Club>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClubEdge = {
  __typename?: 'ClubEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Club;
};

export type ClubFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Content = HighlightEvent | HighlightMedia;

export enum CoordinateSystem {
  Bd09 = 'BD09',
  Gcj02 = 'GCJ02',
  Wgs84 = 'WGS84',
}

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  system: CoordinateSystem;
};

export type Course = {
  __typename?: 'Course';
  club: Club;
  createdAt: Scalars['Timestamp']['output'];
  holes: Array<CourseHole>;
  id: Scalars['Id']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

/**
 * ---
 *
 * ## Junction entity representing the association between courses and holes.
 */
export type CourseHole = {
  __typename?: 'CourseHole';
  annotations: Array<Annotation>;
  clubId?: Maybe<Scalars['Id']['output']>;
  course: Course;
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Id']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Hole number within the course. */
  number: Scalars['Int']['output'];
  /** Par for the hole. */
  par: Scalars['Int']['output'];
  /** Stroke index for the hole. */
  strokeIndex: Scalars['Int']['output'];
  tees: Array<TeeBar>;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unspecified = 'UNSPECIFIED',
}

export type Highlight = {
  __typename?: 'Highlight';
  content: Content;
  createdAt: Scalars['Timestamp']['output'];
  display: HighlightDisplay;
  duration: Scalars['Int']['output'];
  expirationAt?: Maybe<Scalars['Timestamp']['output']>;
  hole: CourseHole;
  id: Scalars['Id']['output'];
  participation: Participation;
  priority: Scalars['Int']['output'];
  repeat: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum HighlightDisplay {
  Maximize = 'MAXIMIZE',
  Minimize = 'MINIMIZE',
  Unspecified = 'UNSPECIFIED',
}

export type HighlightEvent = {
  __typename?: 'HighlightEvent';
  type: HighlightEventType;
};

export enum HighlightEventType {
  Albatross = 'ALBATROSS',
  Birdie = 'BIRDIE',
  Bogey = 'BOGEY',
  DoubleBogey = 'DOUBLE_BOGEY',
  Eagle = 'EAGLE',
  HoleInOne = 'HOLE_IN_ONE',
  Par = 'PAR',
  TripleBogey = 'TRIPLE_BOGEY',
  Unspecified = 'UNSPECIFIED',
}

export type HighlightMedia = {
  __typename?: 'HighlightMedia';
  location?: Maybe<LatLng>;
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  thumbnailUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * ---
 *
 * ## Hole entity represents a single hole on a course.
 */
export type Hole = {
  __typename?: 'Hole';
  annotations: Array<Annotation>;
  courses: Array<Course>;
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Id']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Hole number within the course. */
  number: Scalars['Int']['output'];
  /** Par for the hole. */
  par: Scalars['Int']['output'];
  /** Stroke index for the hole. */
  strokeIndex: Scalars['Int']['output'];
  tees: Array<TeeBar>;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum HoleRange {
  Back = 'BACK',
  Front = 'FRONT',
  Full = 'FULL',
  Unspecified = 'UNSPECIFIED',
}

/** The mode or method by which a player registers/inscribes to a tournament. */
export enum InscriptionMode {
  /**
   * (CAL) Calendar-based registration (scheduled/managed via calendar
   * workflow).
   */
  Calendar = 'CALENDAR',
  /** (EML) Registration submitted/managed via email. */
  Email = 'EMAIL',
  /**
   * (OFF) Offline/club-internal inscription (e.g., at the clubhouse, phone,
   * paper form).
   */
  Offline = 'OFFLINE',
  /** (ONL) Online inscription through web/app. */
  Online = 'ONLINE',
  /** (TST) Test/sandbox mode for trials or non-production runs. */
  Test = 'TEST',
  /** (NON) Unspecified/unknown mode. */
  Unspecified = 'UNSPECIFIED',
}

/**
 * An object that represents a latitude/longitude pair. This is expressed as a
 * pair of doubles to represent degrees latitude and degrees longitude. Unless
 * specified otherwise, this must conform to the
 * <a href="<http://www.unoosa.org/pdf/icg/2012/template/WGS_84.pdf">WGS84>
 * standard</a>. Values must be within normalized ranges.
 */
export type LatLng = {
  __typename?: 'LatLng';
  /** The latitude in degrees. It must be in the range \[-90.0, +90.0\]. */
  latitude: Scalars['Float']['output'];
  /** The longitude in degrees. It must be in the range \[-180.0, +180.0\]. */
  longitude: Scalars['Float']['output'];
};

export type LeaderBoard = {
  __typename?: 'LeaderBoard';
  ranking: Array<LeaderBoardRankingEntry>;
  rounds: Array<LeaderBoardRound>;
  tiePolicy?: Maybe<TieBreakPolicy>;
  tournament: Tournament;
};

export type LeaderBoardRankingEntry = {
  __typename?: 'LeaderBoardRankingEntry';
  participation: Participation;
  playedHoles: Scalars['Int']['output'];
  score?: Maybe<ScoreEntry>;
};

export type LeaderBoardRound = {
  __typename?: 'LeaderBoardRound';
  ranking: Array<LeaderBoardRankingEntry>;
  round: Round;
  tiePolicy?: Maybe<TieBreakPolicy>;
};

export type MutationRoot = {
  __typename?: 'MutationRoot';
  createClub: Club;
  createPlayer: Player;
};

export type MutationRootCreateClubArgs = {
  country: Scalars['String']['input'];
  foundedYear: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type MutationRootCreatePlayerArgs = {
  clubFromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  clubId: Scalars['ID']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  license: Scalars['String']['input'];
};

/** Information about pagination in a connection */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Pagination structure for Relay.
 *
 * This structure defines a standard interface for paginating through
 * resources using cursors. The `after` and `before` fields indicate
 * the boundaries, while `first` and `last` specify how many items to
 * fetch from that boundary.
 *
 * Only one of `first` or `last` should be used at a time. Providing
 * both will result in a validation error.
 *
 * @see <https://relay.dev/graphql/connections.htm#note-95f8a>
 */
export type Pagination = {
  /** Optional cursor after which to return items. */
  after?: InputMaybe<Scalars['Cursor']['input']>;
  /** Optional cursor before which to return items. */
  before?: InputMaybe<Scalars['Cursor']['input']>;
  /** Optional number of items to return after the `after` cursor. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Optional number of items to return before the `before` cursor. */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A representation of a participant's involvement in a tournament round,
 * which may be individual or collective, and can have hierarchical
 * relationships
 */
export type Participation = {
  __typename?: 'Participation';
  created_at: Scalars['Timestamp']['output'];
  depth: Scalars['Int']['output'];
  id: Scalars['Id']['output'];
  lastScoredHole?: Maybe<CourseHole>;
  parentId?: Maybe<Scalars['Id']['output']>;
  players: Array<Player>;
  round: Round;
  startHole?: Maybe<CourseHole>;
  status: ParticipationStatus;
  teeTime?: Maybe<Scalars['String']['output']>;
  type: ParticipationType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum ParticipationStatus {
  Completed = 'COMPLETED',
  Playing = 'PLAYING',
  Unspecified = 'UNSPECIFIED',
  Waiting = 'WAITING',
}

/** The mode or method by which a team/individual participates in a round. */
export enum ParticipationType {
  /** Collective participation (team, pair, etc.). */
  Collective = 'COLLECTIVE',
  /** Individual participation (single player). */
  Individual = 'INDIVIDUAL',
  /** Unset/unknown type. */
  Unspecified = 'UNSPECIFIED',
}

export enum PlayFormat {
  /**
   * (C) Canada Cup: two-player teams with an aggregate (sum-all)
   * result—typically the team’s total is the sum of the two players’ individual
   * totals (per hole or per round, per event rules).
   */
  CanadaCup = 'CANADA_CUP',
  /**
   * (F) Foursome (Alternate Shot): two-player team plays ONE ball, alternating
   * strokes (and tee shots). A single score is recorded for the pair on each
   * hole.
   */
  Foursome = 'FOURSOME',
  /**
   * (P) Four-Ball (Best Ball of Two): two-player teams; each plays their own
   * ball, and the team score for the hole is the lower of the two individual
   * scores.
   */
  FourBall = 'FOUR_BALL',
  /**
   * (G) Greensome: both partners tee off, the team selects the preferred drive,
   * then plays alternate shots with that single ball until holed. One score per
   * pair.
   */
  Greensome = 'GREENSOME',
  /**
   * (H) Greensome Chapman (Chapman/Pinehurst): both partners tee off, then each
   * plays the partner’s ball for the second shot; one ball is then chosen and
   * the team plays alternate shots into the hole. One score per pair.
   */
  GreensomeChapman = 'GREENSOME_CHAPMAN',
  /**
   * (I) Individual: each player plays their own ball; one individual result is
   * recorded.
   */
  Individual = 'INDIVIDUAL',
  /**
   * (A) Professional–Amateur (Pro-Am): a professional pairs with one or more
   * amateurs. One team result is recorded according to the competition’s
   * scoring basis (e.g., best-ball or aggregate).
   */
  ProfessionalAmateur = 'PROFESSIONAL_AMATEUR',
  /**
   * (S) Scramble: teams of 2–4 players; all tee off, the team selects the best
   * shot, and all play from that spot; repeat until holed. One team score per
   * hole.
   */
  Scramble = 'SCRAMBLE',
  /**
   * (E) Team: multi-player team format where a single team result is recorded
   * (per hole or round), using the competition’s defined method (e.g., best-N,
   * aggregate, or similar).
   */
  Team = 'TEAM',
  /** (N) Unspecified play format. */
  Unspecified = 'UNSPECIFIED',
}

export enum PlayStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED',
  Unspecified = 'UNSPECIFIED',
}

/**
 * ---
 *
 * ## Player entity holds player personal and membership data.
 */
export type Player = {
  __typename?: 'Player';
  club: Club;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  /** First name. */
  firstName: Scalars['String']['output'];
  id: Scalars['Id']['output'];
  /** Last name. */
  lastName: Scalars['String']['output'];
  /** External license number. */
  license: Scalars['String']['output'];
  status?: Maybe<PlayerStatus>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type PlayerConnection = {
  __typename?: 'PlayerConnection';
  /** A list of edges. */
  edges: Array<PlayerEdge>;
  /** A list of nodes. */
  nodes: Array<Player>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerEdge = {
  __typename?: 'PlayerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Player;
};

export enum PlayerStatus {
  /** The player has finished the game */
  Finished = 'FINISHED',
  /** The player is currently playing */
  Playing = 'PLAYING',
  /** The player is not currently playing */
  Waiting = 'WAITING',
}

export type QueryRoot = {
  __typename?: 'QueryRoot';
  club: Club;
  clubs: ClubConnection;
  course: Course;
  courses: Array<Course>;
  hole: Hole;
  holes: Array<Hole>;
  leaderBoard: LeaderBoard;
  player: Player;
  playerLiveStats: Scalars['String']['output'];
  players: PlayerConnection;
  round: Round;
  rounds: Array<Round>;
  scoreCard: ScoreCard;
  tournament: Tournament;
  tournaments: TournamentConnection;
  weather: Weather;
};

export type QueryRootClubArgs = {
  by: ClubBy;
};

export type QueryRootClubsArgs = {
  filters?: InputMaybe<Array<ClubFilters>>;
  pagination?: InputMaybe<Pagination>;
};

export type QueryRootCourseArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootCoursesArgs = {
  clubId: Scalars['Id']['input'];
};

export type QueryRootHoleArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootHolesArgs = {
  holeId: Scalars['Id']['input'];
};

export type QueryRootLeaderBoardArgs = {
  calcMode?: InputMaybe<ScoringCalcMode>;
  tournamentId: Scalars['ID']['input'];
};

export type QueryRootPlayerArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRootPlayerLiveStatsArgs = {
  playerId: Scalars['ID']['input'];
  tournamentId: Scalars['ID']['input'];
};

export type QueryRootPlayersArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type QueryRootRoundArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootRoundsArgs = {
  tournamentId: Scalars['Id']['input'];
};

export type QueryRootScoreCardArgs = {
  calcMode?: InputMaybe<ScoringCalcMode>;
  participationId: Scalars['ID']['input'];
};

export type QueryRootTournamentArgs = {
  id: Scalars['Id']['input'];
};

export type QueryRootTournamentsArgs = {
  filters?: InputMaybe<Array<TournamentFilters>>;
  pagination?: InputMaybe<Pagination>;
};

export type QueryRootWeatherArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Result = ScoreEntry | ScoreSpecial;

export type Round = {
  __typename?: 'Round';
  course: Course;
  createdAt: Scalars['Timestamp']['output'];
  endedAt?: Maybe<Scalars['Timestamp']['output']>;
  holes: HoleRange;
  id: Scalars['Id']['output'];
  ordinal: Scalars['Int']['output'];
  participationDepth: Scalars['Int']['output'];
  participations: Array<Participation>;
  playFormat: PlayFormat;
  startedAt: Scalars['Timestamp']['output'];
  status: PlayStatus;
  tournament: Tournament;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum ScoreAggregationKind {
  /** Take the best N member results per hole (e.g., Four-Ball Best-1). */
  BestN = 'BEST_N',
  /** Scramble formats: team plays from selected best shot each stroke. */
  Scramble = 'SCRAMBLE',
  /** Alternate-shot single-ball formats (Foursome/Greensome family). */
  SingleBallAlternate = 'SINGLE_BALL_ALTERNATE',
  /** Sum every member's hole result (typical team aggregate). */
  SumAll = 'SUM_ALL',
  Unspecified = 'UNSPECIFIED',
}

export type ScoreAggregationPolicy = {
  __typename?: 'ScoreAggregationPolicy';
  kind: ScoreAggregationKind;
  /**
   * For BEST_N (and similar), N indicates how many member scores count.
   * Ignored for other kinds.
   */
  n: Scalars['Int']['output'];
};

export type ScoreCard = {
  __typename?: 'ScoreCard';
  aggregationPolicy?: Maybe<ScoreAggregationPolicy>;
  back?: Maybe<ScoreEntry>;
  front?: Maybe<ScoreEntry>;
  holes: Array<ScoreCardHole>;
  participation: Participation;
  playedHoles: Scalars['Int']['output'];
  round: Round;
  total?: Maybe<ScoreEntry>;
  totalHoles: Scalars['Int']['output'];
  tournament: Tournament;
};

export type ScoreCardHole = {
  __typename?: 'ScoreCardHole';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  handicap: Scalars['Int']['output'];
  holeNumber: Scalars['Int']['output'];
  par: Scalars['Int']['output'];
  result: Result;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type ScoreEntry = {
  __typename?: 'ScoreEntry';
  stableford?: Maybe<Scalars['Int']['output']>;
  strokes: Scalars['Int']['output'];
  toPar: Scalars['Int']['output'];
};

export enum ScoreField {
  Stableford = 'STABLEFORD',
  Strokes = 'STROKES',
  ToPar = 'TO_PAR',
  Unspecified = 'UNSPECIFIED',
}

export type ScoreSpecial = {
  __typename?: 'ScoreSpecial';
  kind: ScoreSpecialKind;
  notes: Scalars['String']['output'];
};

export enum ScoreSpecialKind {
  ScoreSpecialPickedUp = 'SCORE_SPECIAL_PICKED_UP',
  ScoreSpecialUnspecified = 'SCORE_SPECIAL_UNSPECIFIED',
}

export enum ScoringCalcMode {
  Handicap = 'HANDICAP',
  Scratch = 'SCRATCH',
  Unspecified = 'UNSPECIFIED',
}

export enum ScoringSystem {
  /**
   * (P) Match Play — holes are scored individually; a hole is won by taking
   * fewer strokes, halved if tied. The match ends when a lead exceeds the
   * number of holes remaining (e.g., “dormie” when lead equals holes left).
   */
  MatchPlay = 'MATCH_PLAY',
  /**
   * (M) Medal Play — total strokes across the entire round are counted; the
   * lowest aggregate wins.
   */
  MedalPlay = 'MEDAL_PLAY',
  /**
   * (S) Stableford — players earn points per hole based on score relative to
   * par, typically adjusted by handicap; higher points total wins.
   */
  Stableford = 'STABLEFORD',
  /**
   * (C) Stroke Play — winner is the player with the fewest total strokes taken
   * to complete the course.
   */
  StrokePlay = 'STROKE_PLAY',
  /** Unset/unknown mode. */
  Unspecified = 'UNSPECIFIED',
}

export enum Sorting {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SubscribePlayerGeopositionResponse = {
  __typename?: 'SubscribePlayerGeopositionResponse';
  coordinates: Coordinates;
  player: Player;
  timestamp: Scalars['Timestamp']['output'];
};

export type SubscriptionRoot = {
  __typename?: 'SubscriptionRoot';
  highlight: Highlight;
  playerTracking: SubscribePlayerGeopositionResponse;
};

export type SubscriptionRootHighlightArgs = {
  tournamentId: Scalars['Id']['input'];
};

export type SubscriptionRootPlayerTrackingArgs = {
  playerId: Scalars['ID']['input'];
};

export type TeeBar = {
  __typename?: 'TeeBar';
  color: TeeColor;
  createdAt: Scalars['Timestamp']['output'];
  gender: Gender;
  length?: Maybe<Scalars['Int']['output']>;
  pace?: Maybe<Scalars['Int']['output']>;
  /**
   * Stroke index (1-18) for this tee bar on the hole,
   * which indicates the relative difficulty of the hole,
   */
  strokeIndex: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export enum TeeColor {
  Black = 'BLACK',
  Blue = 'BLUE',
  Golden = 'GOLDEN',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Red = 'RED',
  Unspecified = 'UNSPECIFIED',
  White = 'WHITE',
  Yellow = 'YELLOW',
}

export enum TieBreakKind {
  /** Compare hole-by-hole from 18 backwards using the given field. */
  HoleByHoleBack = 'HOLE_BY_HOLE_BACK',
  /** Use player/team attribute (e.g., lowest playing handicap wins). */
  LowestHandicap = 'LOWEST_HANDICAP',
  /** Sum the given field over the last N holes (e.g., 18, 9, 6, 3, 1). */
  SumLastNHoles = 'SUM_LAST_N_HOLES',
  Unspecified = 'UNSPECIFIED',
}

export type TieBreakPolicy = {
  __typename?: 'TieBreakPolicy';
  steps: Array<TieBreakSpec>;
};

export type TieBreakSpec = {
  __typename?: 'TieBreakSpec';
  direction: Sorting;
  field: ScoreField;
  kind: TieBreakKind;
  /** used by SUM_LAST_N_HOLES */
  lastNHoles: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type Tournament = {
  __typename?: 'Tournament';
  capacity: Scalars['Int']['output'];
  createdAt: Scalars['Timestamp']['output'];
  host: Club;
  id: Scalars['Id']['output'];
  inscriptionMode: InscriptionMode;
  name: Scalars['String']['output'];
  organizer: Club;
  players: Scalars['Int']['output'];
  rounds: Array<Round>;
  scoringSystem: ScoringSystem;
  status: PlayStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type TournamentConnection = {
  __typename?: 'TournamentConnection';
  /** A list of edges. */
  edges: Array<TournamentEdge>;
  /** A list of nodes. */
  nodes: Array<Tournament>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TournamentEdge = {
  __typename?: 'TournamentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Tournament;
};

export type TournamentFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PlayStatus>>;
};

export type Weather = {
  __typename?: 'Weather';
  condition: Scalars['String']['output'];
  humidityPercent: Scalars['Int']['output'];
  observedAt?: Maybe<Scalars['Timestamp']['output']>;
  precipitationMm: Scalars['Float']['output'];
  pressureHpa: Scalars['Float']['output'];
  temperature?: Maybe<WeatherTemperature>;
  temperatureRange?: Maybe<WeatherTemperatureRange>;
  wind?: Maybe<WeatherWind>;
};

export type WeatherTemperature = {
  __typename?: 'WeatherTemperature';
  celsius: Scalars['Float']['output'];
  fahrenheit: Scalars['Float']['output'];
};

export type WeatherTemperatureRange = {
  __typename?: 'WeatherTemperatureRange';
  avgCelsius: Scalars['Float']['output'];
  maxCelsius: Scalars['Float']['output'];
  minCelsius: Scalars['Float']['output'];
};

export type WeatherWind = {
  __typename?: 'WeatherWind';
  directionCardinal: Scalars['String']['output'];
  directionDegrees: Scalars['Int']['output'];
  speedKph: Scalars['Float']['output'];
  speedMph: Scalars['Float']['output'];
  speedMs: Scalars['Float']['output'];
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  Content: Partial<HighlightEvent> | Partial<HighlightMedia>;
  Result: Partial<ScoreEntry> | Partial<ScoreSpecial>;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Annotation: ResolverTypeWrapper<Partial<Annotation>>;
  Boolean: ResolverTypeWrapper<Partial<Scalars['Boolean']['output']>>;
  Club: ResolverTypeWrapper<Partial<Club>>;
  ClubBy: ResolverTypeWrapper<Partial<ClubBy>>;
  ClubConnection: ResolverTypeWrapper<Partial<ClubConnection>>;
  ClubEdge: ResolverTypeWrapper<Partial<ClubEdge>>;
  ClubFilters: ResolverTypeWrapper<Partial<ClubFilters>>;
  Content: Partial<ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Content']>>;
  CoordinateSystem: ResolverTypeWrapper<Partial<CoordinateSystem>>;
  Coordinates: ResolverTypeWrapper<Partial<Coordinates>>;
  Course: ResolverTypeWrapper<Partial<Course>>;
  CourseHole: ResolverTypeWrapper<Partial<CourseHole>>;
  Cursor: ResolverTypeWrapper<Partial<Scalars['Cursor']['output']>>;
  Float: ResolverTypeWrapper<Partial<Scalars['Float']['output']>>;
  Gender: ResolverTypeWrapper<Partial<Gender>>;
  Highlight: ResolverTypeWrapper<
    Partial<Omit<Highlight, 'content'> & { content: ResolversTypes['Content'] }>
  >;
  HighlightDisplay: ResolverTypeWrapper<Partial<HighlightDisplay>>;
  HighlightEvent: ResolverTypeWrapper<Partial<HighlightEvent>>;
  HighlightEventType: ResolverTypeWrapper<Partial<HighlightEventType>>;
  HighlightMedia: ResolverTypeWrapper<Partial<HighlightMedia>>;
  Hole: ResolverTypeWrapper<Partial<Hole>>;
  HoleRange: ResolverTypeWrapper<Partial<HoleRange>>;
  ID: ResolverTypeWrapper<Partial<Scalars['ID']['output']>>;
  Id: ResolverTypeWrapper<Partial<Scalars['Id']['output']>>;
  InscriptionMode: ResolverTypeWrapper<Partial<InscriptionMode>>;
  Int: ResolverTypeWrapper<Partial<Scalars['Int']['output']>>;
  LatLng: ResolverTypeWrapper<Partial<LatLng>>;
  LeaderBoard: ResolverTypeWrapper<Partial<LeaderBoard>>;
  LeaderBoardRankingEntry: ResolverTypeWrapper<Partial<LeaderBoardRankingEntry>>;
  LeaderBoardRound: ResolverTypeWrapper<Partial<LeaderBoardRound>>;
  MutationRoot: ResolverTypeWrapper<{}>;
  PageInfo: ResolverTypeWrapper<Partial<PageInfo>>;
  Pagination: ResolverTypeWrapper<Partial<Pagination>>;
  Participation: ResolverTypeWrapper<Partial<Participation>>;
  ParticipationStatus: ResolverTypeWrapper<Partial<ParticipationStatus>>;
  ParticipationType: ResolverTypeWrapper<Partial<ParticipationType>>;
  PlayFormat: ResolverTypeWrapper<Partial<PlayFormat>>;
  PlayStatus: ResolverTypeWrapper<Partial<PlayStatus>>;
  Player: ResolverTypeWrapper<Partial<Player>>;
  PlayerConnection: ResolverTypeWrapper<Partial<PlayerConnection>>;
  PlayerEdge: ResolverTypeWrapper<Partial<PlayerEdge>>;
  PlayerStatus: ResolverTypeWrapper<Partial<PlayerStatus>>;
  QueryRoot: ResolverTypeWrapper<{}>;
  Result: Partial<ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Result']>>;
  Round: ResolverTypeWrapper<Partial<Round>>;
  ScoreAggregationKind: ResolverTypeWrapper<Partial<ScoreAggregationKind>>;
  ScoreAggregationPolicy: ResolverTypeWrapper<Partial<ScoreAggregationPolicy>>;
  ScoreCard: ResolverTypeWrapper<
    Partial<Omit<ScoreCard, 'holes'> & { holes: Array<ResolversTypes['ScoreCardHole']> }>
  >;
  ScoreCardHole: ResolverTypeWrapper<
    Partial<Omit<ScoreCardHole, 'result'> & { result: ResolversTypes['Result'] }>
  >;
  ScoreEntry: ResolverTypeWrapper<Partial<ScoreEntry>>;
  ScoreField: ResolverTypeWrapper<Partial<ScoreField>>;
  ScoreSpecial: ResolverTypeWrapper<Partial<ScoreSpecial>>;
  ScoreSpecialKind: ResolverTypeWrapper<Partial<ScoreSpecialKind>>;
  ScoringCalcMode: ResolverTypeWrapper<Partial<ScoringCalcMode>>;
  ScoringSystem: ResolverTypeWrapper<Partial<ScoringSystem>>;
  Sorting: ResolverTypeWrapper<Partial<Sorting>>;
  String: ResolverTypeWrapper<Partial<Scalars['String']['output']>>;
  SubscribePlayerGeopositionResponse: ResolverTypeWrapper<
    Partial<SubscribePlayerGeopositionResponse>
  >;
  SubscriptionRoot: ResolverTypeWrapper<{}>;
  TeeBar: ResolverTypeWrapper<Partial<TeeBar>>;
  TeeColor: ResolverTypeWrapper<Partial<TeeColor>>;
  TieBreakKind: ResolverTypeWrapper<Partial<TieBreakKind>>;
  TieBreakPolicy: ResolverTypeWrapper<Partial<TieBreakPolicy>>;
  TieBreakSpec: ResolverTypeWrapper<Partial<TieBreakSpec>>;
  Timestamp: ResolverTypeWrapper<Partial<Scalars['Timestamp']['output']>>;
  Tournament: ResolverTypeWrapper<Partial<Tournament>>;
  TournamentConnection: ResolverTypeWrapper<Partial<TournamentConnection>>;
  TournamentEdge: ResolverTypeWrapper<Partial<TournamentEdge>>;
  TournamentFilters: ResolverTypeWrapper<Partial<TournamentFilters>>;
  Weather: ResolverTypeWrapper<Partial<Weather>>;
  WeatherTemperature: ResolverTypeWrapper<Partial<WeatherTemperature>>;
  WeatherTemperatureRange: ResolverTypeWrapper<Partial<WeatherTemperatureRange>>;
  WeatherWind: ResolverTypeWrapper<Partial<WeatherWind>>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Annotation: Partial<Annotation>;
  Boolean: Partial<Scalars['Boolean']['output']>;
  Club: Partial<Club>;
  ClubBy: Partial<ClubBy>;
  ClubConnection: Partial<ClubConnection>;
  ClubEdge: Partial<ClubEdge>;
  ClubFilters: Partial<ClubFilters>;
  Content: Partial<ResolversUnionTypes<ResolversParentTypes>['Content']>;
  Coordinates: Partial<Coordinates>;
  Course: Partial<Course>;
  CourseHole: Partial<CourseHole>;
  Cursor: Partial<Scalars['Cursor']['output']>;
  Float: Partial<Scalars['Float']['output']>;
  Highlight: Partial<Omit<Highlight, 'content'> & { content: ResolversParentTypes['Content'] }>;
  HighlightEvent: Partial<HighlightEvent>;
  HighlightMedia: Partial<HighlightMedia>;
  Hole: Partial<Hole>;
  ID: Partial<Scalars['ID']['output']>;
  Id: Partial<Scalars['Id']['output']>;
  Int: Partial<Scalars['Int']['output']>;
  LatLng: Partial<LatLng>;
  LeaderBoard: Partial<LeaderBoard>;
  LeaderBoardRankingEntry: Partial<LeaderBoardRankingEntry>;
  LeaderBoardRound: Partial<LeaderBoardRound>;
  MutationRoot: {};
  PageInfo: Partial<PageInfo>;
  Pagination: Partial<Pagination>;
  Participation: Partial<Participation>;
  Player: Partial<Player>;
  PlayerConnection: Partial<PlayerConnection>;
  PlayerEdge: Partial<PlayerEdge>;
  QueryRoot: {};
  Result: Partial<ResolversUnionTypes<ResolversParentTypes>['Result']>;
  Round: Partial<Round>;
  ScoreAggregationPolicy: Partial<ScoreAggregationPolicy>;
  ScoreCard: Partial<
    Omit<ScoreCard, 'holes'> & { holes: Array<ResolversParentTypes['ScoreCardHole']> }
  >;
  ScoreCardHole: Partial<
    Omit<ScoreCardHole, 'result'> & { result: ResolversParentTypes['Result'] }
  >;
  ScoreEntry: Partial<ScoreEntry>;
  ScoreSpecial: Partial<ScoreSpecial>;
  String: Partial<Scalars['String']['output']>;
  SubscribePlayerGeopositionResponse: Partial<SubscribePlayerGeopositionResponse>;
  SubscriptionRoot: {};
  TeeBar: Partial<TeeBar>;
  TieBreakPolicy: Partial<TieBreakPolicy>;
  TieBreakSpec: Partial<TieBreakSpec>;
  Timestamp: Partial<Scalars['Timestamp']['output']>;
  Tournament: Partial<Tournament>;
  TournamentConnection: Partial<TournamentConnection>;
  TournamentEdge: Partial<TournamentEdge>;
  TournamentFilters: Partial<TournamentFilters>;
  Weather: Partial<Weather>;
  WeatherTemperature: Partial<WeatherTemperature>;
  WeatherTemperatureRange: Partial<WeatherTemperatureRange>;
  WeatherWind: Partial<WeatherWind>;
};

export type AnnotationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Annotation'] = ResolversParentTypes['Annotation'],
> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coordinates?: Resolver<ResolversTypes['LatLng'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClubResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Club'] = ResolversParentTypes['Club'],
> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  courses?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  foundedYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  holes?: Resolver<Array<ResolversTypes['Hole']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  players?: Resolver<Array<ResolversTypes['Player']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClubConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ClubConnection'] = ResolversParentTypes['ClubConnection'],
> = {
  edges?: Resolver<Array<ResolversTypes['ClubEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Club']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClubEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ClubEdge'] = ResolversParentTypes['ClubEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Content'] = ResolversParentTypes['Content'],
> = {
  __resolveType: TypeResolveFn<'HighlightEvent' | 'HighlightMedia', ParentType, ContextType>;
};

export type CoordinatesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Coordinates'] = ResolversParentTypes['Coordinates'],
> = {
  latitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  system?: Resolver<ResolversTypes['CoordinateSystem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Course'] = ResolversParentTypes['Course'],
> = {
  club?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  holes?: Resolver<Array<ResolversTypes['CourseHole']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CourseHoleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CourseHole'] = ResolversParentTypes['CourseHole'],
> = {
  annotations?: Resolver<Array<ResolversTypes['Annotation']>, ParentType, ContextType>;
  clubId?: Resolver<Maybe<ResolversTypes['Id']>, ParentType, ContextType>;
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  par?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  strokeIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tees?: Resolver<Array<ResolversTypes['TeeBar']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CursorScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Cursor'], any> {
  name: 'Cursor';
}

export type HighlightResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Highlight'] = ResolversParentTypes['Highlight'],
> = {
  content?: Resolver<ResolversTypes['Content'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  display?: Resolver<ResolversTypes['HighlightDisplay'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expirationAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  hole?: Resolver<ResolversTypes['CourseHole'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  participation?: Resolver<ResolversTypes['Participation'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  repeat?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightEventResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HighlightEvent'] = ResolversParentTypes['HighlightEvent'],
> = {
  type?: Resolver<ResolversTypes['HighlightEventType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HighlightMediaResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['HighlightMedia'] = ResolversParentTypes['HighlightMedia'],
> = {
  location?: Resolver<Maybe<ResolversTypes['LatLng']>, ParentType, ContextType>;
  mimeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizeBytes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HoleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Hole'] = ResolversParentTypes['Hole'],
> = {
  annotations?: Resolver<Array<ResolversTypes['Annotation']>, ParentType, ContextType>;
  courses?: Resolver<Array<ResolversTypes['Course']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  par?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  strokeIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tees?: Resolver<Array<ResolversTypes['TeeBar']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface IdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Id'], any> {
  name: 'Id';
}

export type LatLngResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LatLng'] = ResolversParentTypes['LatLng'],
> = {
  latitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderBoardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LeaderBoard'] = ResolversParentTypes['LeaderBoard'],
> = {
  ranking?: Resolver<Array<ResolversTypes['LeaderBoardRankingEntry']>, ParentType, ContextType>;
  rounds?: Resolver<Array<ResolversTypes['LeaderBoardRound']>, ParentType, ContextType>;
  tiePolicy?: Resolver<Maybe<ResolversTypes['TieBreakPolicy']>, ParentType, ContextType>;
  tournament?: Resolver<ResolversTypes['Tournament'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderBoardRankingEntryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LeaderBoardRankingEntry'] = ResolversParentTypes['LeaderBoardRankingEntry'],
> = {
  participation?: Resolver<ResolversTypes['Participation'], ParentType, ContextType>;
  playedHoles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['ScoreEntry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderBoardRoundResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LeaderBoardRound'] = ResolversParentTypes['LeaderBoardRound'],
> = {
  ranking?: Resolver<Array<ResolversTypes['LeaderBoardRankingEntry']>, ParentType, ContextType>;
  round?: Resolver<ResolversTypes['Round'], ParentType, ContextType>;
  tiePolicy?: Resolver<Maybe<ResolversTypes['TieBreakPolicy']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationRootResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MutationRoot'] = ResolversParentTypes['MutationRoot'],
> = {
  createClub?: Resolver<
    ResolversTypes['Club'],
    ParentType,
    ContextType,
    RequireFields<MutationRootCreateClubArgs, 'country' | 'foundedYear' | 'name' | 'slug'>
  >;
  createPlayer?: Resolver<
    ResolversTypes['Player'],
    ParentType,
    ContextType,
    RequireFields<MutationRootCreatePlayerArgs, 'clubId' | 'firstName' | 'lastName' | 'license'>
  >;
};

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ParticipationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Participation'] = ResolversParentTypes['Participation'],
> = {
  created_at?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  depth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  lastScoredHole?: Resolver<Maybe<ResolversTypes['CourseHole']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['Id']>, ParentType, ContextType>;
  players?: Resolver<Array<ResolversTypes['Player']>, ParentType, ContextType>;
  round?: Resolver<ResolversTypes['Round'], ParentType, ContextType>;
  startHole?: Resolver<Maybe<ResolversTypes['CourseHole']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ParticipationStatus'], ParentType, ContextType>;
  teeTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ParticipationType'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Player'] = ResolversParentTypes['Player'],
> = {
  club?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  license?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PlayerStatus']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['PlayerConnection'] = ResolversParentTypes['PlayerConnection'],
> = {
  edges?: Resolver<Array<ResolversTypes['PlayerEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Player']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlayerEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PlayerEdge'] = ResolversParentTypes['PlayerEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Player'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryRootResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['QueryRoot'] = ResolversParentTypes['QueryRoot'],
> = {
  club?: Resolver<
    ResolversTypes['Club'],
    ParentType,
    ContextType,
    RequireFields<QueryRootClubArgs, 'by'>
  >;
  clubs?: Resolver<
    ResolversTypes['ClubConnection'],
    ParentType,
    ContextType,
    Partial<QueryRootClubsArgs>
  >;
  course?: Resolver<
    ResolversTypes['Course'],
    ParentType,
    ContextType,
    RequireFields<QueryRootCourseArgs, 'id'>
  >;
  courses?: Resolver<
    Array<ResolversTypes['Course']>,
    ParentType,
    ContextType,
    RequireFields<QueryRootCoursesArgs, 'clubId'>
  >;
  hole?: Resolver<
    ResolversTypes['Hole'],
    ParentType,
    ContextType,
    RequireFields<QueryRootHoleArgs, 'id'>
  >;
  holes?: Resolver<
    Array<ResolversTypes['Hole']>,
    ParentType,
    ContextType,
    RequireFields<QueryRootHolesArgs, 'holeId'>
  >;
  leaderBoard?: Resolver<
    ResolversTypes['LeaderBoard'],
    ParentType,
    ContextType,
    RequireFields<QueryRootLeaderBoardArgs, 'tournamentId'>
  >;
  player?: Resolver<
    ResolversTypes['Player'],
    ParentType,
    ContextType,
    RequireFields<QueryRootPlayerArgs, 'id'>
  >;
  playerLiveStats?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType,
    RequireFields<QueryRootPlayerLiveStatsArgs, 'playerId' | 'tournamentId'>
  >;
  players?: Resolver<
    ResolversTypes['PlayerConnection'],
    ParentType,
    ContextType,
    Partial<QueryRootPlayersArgs>
  >;
  round?: Resolver<
    ResolversTypes['Round'],
    ParentType,
    ContextType,
    RequireFields<QueryRootRoundArgs, 'id'>
  >;
  rounds?: Resolver<
    Array<ResolversTypes['Round']>,
    ParentType,
    ContextType,
    RequireFields<QueryRootRoundsArgs, 'tournamentId'>
  >;
  scoreCard?: Resolver<
    ResolversTypes['ScoreCard'],
    ParentType,
    ContextType,
    RequireFields<QueryRootScoreCardArgs, 'participationId'>
  >;
  tournament?: Resolver<
    ResolversTypes['Tournament'],
    ParentType,
    ContextType,
    RequireFields<QueryRootTournamentArgs, 'id'>
  >;
  tournaments?: Resolver<
    ResolversTypes['TournamentConnection'],
    ParentType,
    ContextType,
    Partial<QueryRootTournamentsArgs>
  >;
  weather?: Resolver<
    ResolversTypes['Weather'],
    ParentType,
    ContextType,
    RequireFields<QueryRootWeatherArgs, 'latitude' | 'longitude'>
  >;
};

export type ResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Result'] = ResolversParentTypes['Result'],
> = {
  __resolveType: TypeResolveFn<'ScoreEntry' | 'ScoreSpecial', ParentType, ContextType>;
};

export type RoundResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Round'] = ResolversParentTypes['Round'],
> = {
  course?: Resolver<ResolversTypes['Course'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  holes?: Resolver<ResolversTypes['HoleRange'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  ordinal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  participationDepth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  participations?: Resolver<Array<ResolversTypes['Participation']>, ParentType, ContextType>;
  playFormat?: Resolver<ResolversTypes['PlayFormat'], ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlayStatus'], ParentType, ContextType>;
  tournament?: Resolver<ResolversTypes['Tournament'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreAggregationPolicyResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ScoreAggregationPolicy'] = ResolversParentTypes['ScoreAggregationPolicy'],
> = {
  kind?: Resolver<ResolversTypes['ScoreAggregationKind'], ParentType, ContextType>;
  n?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreCardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScoreCard'] = ResolversParentTypes['ScoreCard'],
> = {
  aggregationPolicy?: Resolver<
    Maybe<ResolversTypes['ScoreAggregationPolicy']>,
    ParentType,
    ContextType
  >;
  back?: Resolver<Maybe<ResolversTypes['ScoreEntry']>, ParentType, ContextType>;
  front?: Resolver<Maybe<ResolversTypes['ScoreEntry']>, ParentType, ContextType>;
  holes?: Resolver<Array<ResolversTypes['ScoreCardHole']>, ParentType, ContextType>;
  participation?: Resolver<ResolversTypes['Participation'], ParentType, ContextType>;
  playedHoles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  round?: Resolver<ResolversTypes['Round'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['ScoreEntry']>, ParentType, ContextType>;
  totalHoles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tournament?: Resolver<ResolversTypes['Tournament'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreCardHoleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScoreCardHole'] = ResolversParentTypes['ScoreCardHole'],
> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  handicap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  holeNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  par?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  result?: Resolver<ResolversTypes['Result'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScoreEntry'] = ResolversParentTypes['ScoreEntry'],
> = {
  stableford?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  strokes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toPar?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoreSpecialResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ScoreSpecial'] = ResolversParentTypes['ScoreSpecial'],
> = {
  kind?: Resolver<ResolversTypes['ScoreSpecialKind'], ParentType, ContextType>;
  notes?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscribePlayerGeopositionResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SubscribePlayerGeopositionResponse'] = ResolversParentTypes['SubscribePlayerGeopositionResponse'],
> = {
  coordinates?: Resolver<ResolversTypes['Coordinates'], ParentType, ContextType>;
  player?: Resolver<ResolversTypes['Player'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionRootResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SubscriptionRoot'] = ResolversParentTypes['SubscriptionRoot'],
> = {
  highlight?: SubscriptionResolver<
    ResolversTypes['Highlight'],
    'highlight',
    ParentType,
    ContextType,
    RequireFields<SubscriptionRootHighlightArgs, 'tournamentId'>
  >;
  playerTracking?: SubscriptionResolver<
    ResolversTypes['SubscribePlayerGeopositionResponse'],
    'playerTracking',
    ParentType,
    ContextType,
    RequireFields<SubscriptionRootPlayerTrackingArgs, 'playerId'>
  >;
};

export type TeeBarResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TeeBar'] = ResolversParentTypes['TeeBar'],
> = {
  color?: Resolver<ResolversTypes['TeeColor'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['Gender'], ParentType, ContextType>;
  length?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pace?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  strokeIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TieBreakPolicyResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TieBreakPolicy'] = ResolversParentTypes['TieBreakPolicy'],
> = {
  steps?: Resolver<Array<ResolversTypes['TieBreakSpec']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TieBreakSpecResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TieBreakSpec'] = ResolversParentTypes['TieBreakSpec'],
> = {
  direction?: Resolver<ResolversTypes['Sorting'], ParentType, ContextType>;
  field?: Resolver<ResolversTypes['ScoreField'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['TieBreakKind'], ParentType, ContextType>;
  lastNHoles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimestampScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Timestamp'], any> {
  name: 'Timestamp';
}

export type TournamentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tournament'] = ResolversParentTypes['Tournament'],
> = {
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Id'], ParentType, ContextType>;
  inscriptionMode?: Resolver<ResolversTypes['InscriptionMode'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizer?: Resolver<ResolversTypes['Club'], ParentType, ContextType>;
  players?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rounds?: Resolver<Array<ResolversTypes['Round']>, ParentType, ContextType>;
  scoringSystem?: Resolver<ResolversTypes['ScoringSystem'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PlayStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TournamentConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TournamentConnection'] = ResolversParentTypes['TournamentConnection'],
> = {
  edges?: Resolver<Array<ResolversTypes['TournamentEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Tournament']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TournamentEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TournamentEdge'] = ResolversParentTypes['TournamentEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Tournament'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeatherResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Weather'] = ResolversParentTypes['Weather'],
> = {
  condition?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  humidityPercent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  observedAt?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  precipitationMm?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pressureHpa?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['WeatherTemperature']>, ParentType, ContextType>;
  temperatureRange?: Resolver<
    Maybe<ResolversTypes['WeatherTemperatureRange']>,
    ParentType,
    ContextType
  >;
  wind?: Resolver<Maybe<ResolversTypes['WeatherWind']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeatherTemperatureResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['WeatherTemperature'] = ResolversParentTypes['WeatherTemperature'],
> = {
  celsius?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fahrenheit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeatherTemperatureRangeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['WeatherTemperatureRange'] = ResolversParentTypes['WeatherTemperatureRange'],
> = {
  avgCelsius?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxCelsius?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minCelsius?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeatherWindResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WeatherWind'] = ResolversParentTypes['WeatherWind'],
> = {
  directionCardinal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  directionDegrees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  speedKph?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  speedMph?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  speedMs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Annotation?: AnnotationResolvers<ContextType>;
  Club?: ClubResolvers<ContextType>;
  ClubConnection?: ClubConnectionResolvers<ContextType>;
  ClubEdge?: ClubEdgeResolvers<ContextType>;
  Content?: ContentResolvers<ContextType>;
  Coordinates?: CoordinatesResolvers<ContextType>;
  Course?: CourseResolvers<ContextType>;
  CourseHole?: CourseHoleResolvers<ContextType>;
  Cursor?: GraphQLScalarType;
  Highlight?: HighlightResolvers<ContextType>;
  HighlightEvent?: HighlightEventResolvers<ContextType>;
  HighlightMedia?: HighlightMediaResolvers<ContextType>;
  Hole?: HoleResolvers<ContextType>;
  Id?: GraphQLScalarType;
  LatLng?: LatLngResolvers<ContextType>;
  LeaderBoard?: LeaderBoardResolvers<ContextType>;
  LeaderBoardRankingEntry?: LeaderBoardRankingEntryResolvers<ContextType>;
  LeaderBoardRound?: LeaderBoardRoundResolvers<ContextType>;
  MutationRoot?: MutationRootResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Participation?: ParticipationResolvers<ContextType>;
  Player?: PlayerResolvers<ContextType>;
  PlayerConnection?: PlayerConnectionResolvers<ContextType>;
  PlayerEdge?: PlayerEdgeResolvers<ContextType>;
  QueryRoot?: QueryRootResolvers<ContextType>;
  Result?: ResultResolvers<ContextType>;
  Round?: RoundResolvers<ContextType>;
  ScoreAggregationPolicy?: ScoreAggregationPolicyResolvers<ContextType>;
  ScoreCard?: ScoreCardResolvers<ContextType>;
  ScoreCardHole?: ScoreCardHoleResolvers<ContextType>;
  ScoreEntry?: ScoreEntryResolvers<ContextType>;
  ScoreSpecial?: ScoreSpecialResolvers<ContextType>;
  SubscribePlayerGeopositionResponse?: SubscribePlayerGeopositionResponseResolvers<ContextType>;
  SubscriptionRoot?: SubscriptionRootResolvers<ContextType>;
  TeeBar?: TeeBarResolvers<ContextType>;
  TieBreakPolicy?: TieBreakPolicyResolvers<ContextType>;
  TieBreakSpec?: TieBreakSpecResolvers<ContextType>;
  Timestamp?: GraphQLScalarType;
  Tournament?: TournamentResolvers<ContextType>;
  TournamentConnection?: TournamentConnectionResolvers<ContextType>;
  TournamentEdge?: TournamentEdgeResolvers<ContextType>;
  Weather?: WeatherResolvers<ContextType>;
  WeatherTemperature?: WeatherTemperatureResolvers<ContextType>;
  WeatherTemperatureRange?: WeatherTemperatureRangeResolvers<ContextType>;
  WeatherWind?: WeatherWindResolvers<ContextType>;
};
